import moment from "moment-timezone";

const OSLO = "Europe/Oslo";

// Mirrors EeaTimeLimits and NorwegianWorkingDays in bff/domain/.../common/util, which the BFF judges by.
const easterSunday = (year: number): moment.Moment => {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return moment.tz({ year, month: month - 1, day }, OSLO);
};

const publicHolidays = (year: number): Set<string> => {
  const easter = easterSunday(year);
  const fromEaster = (days: number) => easter.clone().add(days, "days").format("YYYY-MM-DD");
  return new Set([
    `${year}-01-01`,
    fromEaster(-3),
    fromEaster(-2),
    fromEaster(1),
    `${year}-05-01`,
    `${year}-05-17`,
    fromEaster(39),
    fromEaster(50),
    `${year}-12-25`,
    `${year}-12-26`,
  ]);
};

export const isNorwegianWorkingDay = (day: moment.Moment): boolean => {
  const weekday = day.isoWeekday();
  return weekday < 6 && !publicHolidays(day.year()).has(day.format("YYYY-MM-DD"));
};

// Regulation (EEC, Euratom) No 1182/71 art. 3, as taken into the EEA Agreement: a period of days starts
// the day after the event and ends at the end of its last day, moved to the next working day.
export const eeaPeriodEnd = (event: moment.MomentInput, days: number): moment.Moment => {
  const lastDay = moment(event).tz(OSLO).startOf("day").add(days, "days");
  while (!isNorwegianWorkingDay(lastDay)) lastDay.add(1, "day");
  return endOf(lastDay);
};

export const eeaWholeDays = (event: moment.MomentInput, deadline: moment.MomentInput): number => {
  const firstDay = moment(event).tz(OSLO).startOf("day");
  const at = moment(deadline).tz(OSLO);
  const lastDay = at.clone().startOf("day");
  const days = Math.round(lastDay.diff(firstDay, "days", true));
  return at.isBefore(endOf(lastDay)) ? days - 1 : days;
};

const endOf = (day: moment.Moment): moment.Moment => day.clone().startOf("day").hour(23).minute(59);
